export const JSVoidString = 'javascript:void(0);';